export const LABELS = {
  actionListCompletedDescription: 'Done, closed, fixed, resolved',
  actionListNotPlannedDescription: "Won't fix, can't repro, duplicate, stale",
  closeAsCompleted: 'Close as completed',
  closeAsNotPlanned: 'Close as not planned',
  moreOptions: 'More options',
  reOpenIssue: 'Reopen Issue',
  updateIssueRoleDescription: 'update issue state options menu',
}
